var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 29.929,
    viewBox: "0 0 48 29.929",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa",
    transform: "translate(-4.988 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa-2",
    "data-name": "Visa",
    transform: "translate(4.988 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-20",
    width: 48,
    height: 23.619,
    transform: "translate(0 3.048)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-1",
    d: "M44.294,0H2.394A2.575,2.575,0,0,0,0,2.394V5.986H47.886V3.591Q47.886,0,44.294,0Zm0,0",
    transform: "translate(0.009 0)",
    fill: "#265697",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-1-2",
    "data-name": "Rectangle-1",
    d: "M0,80s0,0,0,2.394,1.2,3.591,3.591,3.591h40.7q3.591,0,3.591-3.591V80Zm0,0",
    transform: "translate(0.009 -56.057)",
    fill: "#d97b16",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M87.816,28.533A8.583,8.583,0,0,0,84.78,28c-3.347,0-5.7,1.722-5.725,4.191-.019,1.825,1.683,2.843,2.968,3.45,1.319.622,1.762,1.019,1.755,1.575-.008.851-1.053,1.24-2.027,1.24a6.973,6.973,0,0,1-3.189-.667l-.437-.2-.475,2.843a10.522,10.522,0,0,0,3.773.678c3.561,0,5.872-1.7,5.9-4.339.013-1.445-.89-2.544-2.844-3.45-1.184-.587-1.909-.979-1.9-1.574,0-.528.614-1.092,1.94-1.092a6.134,6.134,0,0,1,2.535.487l.3.147.459-2.752",
    transform: "translate(-54.403 -19.62)",
    fill: "#265697",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M118.578,28.778h-2.618a1.68,1.68,0,0,0-1.774,1.053l-5.031,11.638h3.557s.582-1.565.713-1.908l4.338.005c.1.445.412,1.9.412,1.9h3.143l-2.742-12.691ZM114.4,36.963c.28-.732,1.35-3.55,1.35-3.55-.02.034.278-.735.449-1.212l.229,1.095s.649,3.031.784,3.667Zm0,0",
    transform: "translate(-76.478 -20.165)",
    fill: "#265697",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M59.25,41.436l2.118-12.7h3.387l-2.119,12.7Zm0,0",
    transform: "translate(-41.508 -20.137)",
    fill: "#265697",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M30.181,28.768l-3.316,8.66-.353-1.76a9.842,9.842,0,0,0-4.691-5.327l3.032,11.106,3.584,0,5.333-12.675H30.181",
    transform: "translate(-15.28 -20.158)",
    fill: "#265697",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M15.506,28.742H10.043L10,29.006c4.25,1.051,7.062,3.591,8.229,6.644l-1.188-5.836a1.42,1.42,0,0,0-1.536-1.072",
    transform: "translate(-6.998 -20.14)",
    fill: "#d97b16",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.7b979d1bc090b788d4a444e044828cbf.svg";
export { ForwardRef as ReactComponent };